module.exports = __webpack_public_path__ + "static/1-8075d4efbf6e21790b19e98ec97475fc.png";